export default {
  title: 'Talk to Customers',
  userId: 'User#',
  nick: 'Nick',
  chatCreation: 'Chat creation time',
  orderSerial: 'Order Serial',
  orderDate: 'Order date',
  paymentType: 'Payment Type',
  amount: 'Amount',
  orderNo: 'Order No.',
  orderTime: 'Order Time.',
  total: 'Total',
  item: 'items',
  receiverInformation: 'Receiver Information',
  name: 'Name',
  phone: 'Phone',
  addres: 'Addres',
  remarks: 'Remarks',
  confirmTime: 'ConfirmTime',
  userConfirmed: 'User Confirmed',
  userUnconfirmed: 'User Unconfirmed',
  shipOrderNo: 'ShipOrder No.',
  placeholder1: 'Enter something...',
  send: 'Send',
  clear: 'Clear',
  reply: 'Fast reply',
  fastreply1: 'Welcome to our store. Please feel free to ask any question.',
  fastreply2: 'Sorry about the late. The order is for global product and it will take about 15-30 workdays to arrive in Dhaka. Please wait. You can track the order in the order detail anytime.',
  fastreply3: 'Yes we have it in stock, please add it to cart and check out. You will receive the item in a few days.',
  fastreply4: 'We are sorry that we don\'t have the product in stock. Would you like to cancel the order?',
  fastreply5: 'Sorry we can\'t cancel the order as it has already been dispatched and will arrive in Dhaka soon. Would you please wait a bit longer and we are sure you will receive it in shortest time.',
  contentListServer: 'ulvinar sodales ut in libero. Sed lobortis vitae est sit amet sodales.',
  pamentType1: 'Online',
  pamentType2: 'COD',
  pamentType3: 'Coin Redeem',
  pamentType4: 'Voucher Redeem',
  // =====================新增============2021/3/8
  newAfterRequest: 'The customer applies for after-sales, please deal with it as soon as possible',
  afterSaleID: 'After Sale ID',
  orderNum: 'Order Number',
  user: 'User',
  afterSaleRequest: 'Apply for after sales',
  afterSaleMethod1: 'Exchange',
  afterSaleMethod2: 'Return and refund',
  afterSaleMethod3: 'Repair',
  afterSaleMethod4: 'Only refund',
  afterSaleMethod5: 'Resend'
}
